import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('discardSenderSubjectOption')(function discardSenderSubjectOption(state) {
    var optionState = state.optionState;
    optionState.showSenderOnTopInListView = null;
}));
//# sourceMappingURL=discardSenderSubjectOption.js.map